const SHOW_MESSAGE: string = 'SHOW_MESSAGE'
const CLOSE_MESSAGE: string = 'CLOSE_MESSAGE'
const SHOW_SUCCESS_BAR: string = 'SHOW_SUCCESS_BAR'
const CLOSE_SUCCESS_BAR: string = 'CLOSE_SUCCESS_BAR'

export { SHOW_MESSAGE, CLOSE_MESSAGE, SHOW_SUCCESS_BAR, CLOSE_SUCCESS_BAR }
